import { useEffect } from "react";
import { siteOrigin } from "../lib/siteConfig";
import { trackPageView } from "../lib/analytics";

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export default function Seo({ title, description, image, canonical, noindex, jsonLd }) {
  useEffect(() => {
    const fullTitle = title ? `${title}` : "CaminoSapiens — Art of the Long Walk";
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    const absImg = image && image.startsWith("/") ? siteOrigin() + image : image;
    setMeta("property", "og:title", title || "CaminoSapiens");
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    if (absImg) setMeta("property", "og:image", absImg);
    setMeta("name", "twitter:card", absImg ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", title || "CaminoSapiens");
    setMeta("name", "twitter:description", description);
    if (absImg) setMeta("name", "twitter:image", absImg);

    const url = canonical || (siteOrigin() + window.location.pathname);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
    // og:url must always match the canonical (same source, never independently built) so the two
    // can't drift. Uses window.location.pathname (no query string / tracking params).
    setMeta("property", "og:url", url);

    document.querySelectorAll('script[data-seo-jsonld="true"]').forEach((n) => n.remove());
    if (jsonLd) {
      const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      blocks.forEach((b) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-seo-jsonld", "true");
        s.text = JSON.stringify(b);
        document.head.appendChild(s);
      });
    }
    // Fire the GA4 page_view here — the title is now set, so it's reported correctly
    // (including on deep/direct loads where the title depends on async data).
    trackPageView(window.location.pathname);
  }, [title, description, image, canonical, noindex, jsonLd]);

  return null;
}
